import { render } from "./readCategory.vue?vue&type=template&id=a9e1de70&scoped=true"
import script from "./readCategory.vue?vue&type=script&lang=js"
export * from "./readCategory.vue?vue&type=script&lang=js"

import "./readCategory.vue?vue&type=style&index=0&id=a9e1de70&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e1de70"]])

export default __exports__